export const getPatternUrls = patterns => {
  if (!patterns) return [];
  return patterns.map(pattern => `url(#${pattern.props.id})`);
};